import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import TechnologistConfig from '@/models/interfaces/Technologist';

export default class TechnologistAPI {
    public static async getAll() {
        let technologists;
        try {
            technologists = await ApiController.get(ApiRoutes.technologistCms.get) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(technologists);
    }

    public static async getById(id: string) {
        let technologist;
        try {
            technologist = await ApiController.get(ApiRoutes.technologistCms.getById(id)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(technologist);
    }

    public static async update(id: string, info: TechnologistConfig) {
        let technologist;
        const request = {
            data: {
                type: 'technologists',
                id,
                attributes: {},
            },
        };

        if (info.name) {
            // @ts-ignore
            request.data.attributes.name = info.name;
        }

        if (info.isActive !== undefined) {
            // @ts-ignore
            request.data.attributes.isActive = info.isActive;
        }

        try {
            technologist = await ApiController.patch(
                ApiRoutes.technologistCms.update(id),
                request,
            ) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(technologist);
    }

    public static async delete(id: string) {
        try {
            await ApiController.delete(ApiRoutes.technologistCms.delete(id));
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }

    public static async create(info: TechnologistConfig) {
        let technologist;
        const request = {
            data: {
                type: 'technologists',
                attributes: {
                    name: info.name,
                    isActive: info.isActive ?? true,
                },
            },
        };

        try {
            technologist = await ApiController.post(
                ApiRoutes.technologistCms.create,
                request,
            ) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(technologist);
    }
}